// extracted by mini-css-extract-plugin
module.exports = {"stop":"stop--Mhx6"};